import * as colors from '../assets/colors';
import * as fonts from '../assets/fonts';
import media from '../assets/media';
export default {
  colors: colors,
  fonts: fonts,
  media: media
};